import { Grid } from "@mui/material";
import { Outlet } from "react-router-dom";

import SideBar from "./SideBar";

type Props = {};

function ProfileOutlet(_props: Props) {
  return (
    <Grid container position="relative" height="100%" spacing={2}>
      <Grid size={{ xs: 2 }} height="100%">
        <SideBar />
      </Grid>
      <Grid size={{ xs: 10 }}>
        <Outlet />
      </Grid>
    </Grid>
  );
}

export default ProfileOutlet;
